__turbopack_context__.v({
  "betaText": "GamepadsModal-module__VHEybq__betaText",
  "closeBtnWrapper": "GamepadsModal-module__VHEybq__closeBtnWrapper",
  "contentWrapper": "GamepadsModal-module__VHEybq__contentWrapper",
  "devicesWrapper": "GamepadsModal-module__VHEybq__devicesWrapper",
  "gamepadsModal": "GamepadsModal-module__VHEybq__gamepadsModal",
  "headerWrapper": "GamepadsModal-module__VHEybq__headerWrapper",
  "mainWrapper": "GamepadsModal-module__VHEybq__mainWrapper",
  "maxControlsTxt": "GamepadsModal-module__VHEybq__maxControlsTxt",
  "optionsWrapper": "GamepadsModal-module__VHEybq__optionsWrapper",
});
